<template>
  <div class="doctor_form_side">
    <div class="doctor_form_fixed">
      <div class="doctor_form_logo">
        <div>
          <img class="doctor_form_logo_style" src="../src/assets/logo.png" alt="" srcset="">
        </div>
        <div class="doctor_form_logo_title">医師モニター評価サービス事業</div>
      </div>
      <div class="doctor_form_content">
        <div>
          <div class="doctor_form_head_banner">
          </div>
          <div class="doctor_form_head_title">
            CGM Medical参加登録書
          </div>
        </div>
        <div class="doctor_form_body">
          <div class="doctor_form_body_widget2">
            <div>専門</div>
            <el-select v-model="doctor_form.doctorMajor">
              <el-option v-for="item in doctor_major_options" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </div>
          <div class="doctor_form_body_widget">
            <div>
              <el-checkbox v-model="doctor_form.doctorRecommend" :false-label="0" :true-label="1">医師推奨マーク</el-checkbox>
            </div>
            <div>
              <el-checkbox v-model="doctor_form.doctorProducer" :false-label="0" :true-label="1">医師イチオシサービス</el-checkbox>
            </div>
          </div>
          <div class="doctor_form_body_widget1">
            <div>◆クリニック情報</div>
            <div class="doctor_form_widget_line"></div>
          </div>
          <div class="doctor_form_body_widget2">
            <div>クリニック名称</div>
            <el-input v-model="doctor_form.clinicName"></el-input>
          </div>
          <div class="doctor_form_body_widget2">
            <div>クリニック名称ふりがな</div>
            <el-input v-model="doctor_form.clinicNameKana"></el-input>
          </div>
          <div class="doctor_form_body_widget2">
            <div>設立年月日</div>
            <!-- <el-date-picker v-model="doctor_form.clinicCreate" type="date" placeholder="選択してください"
              value-format="yyyy-MM-dd">
            </el-date-picker> -->
            <el-select v-model="year" placeholder="----" @change="year_change">
              <el-option v-for="item in years" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
            <span class="date_separator_style">/</span>
            <el-select v-model="month" placeholder="--" @change="month_change">
              <el-option v-for="item in months" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
            <span class="date_separator_style">/</span>
            <el-select v-model="day" placeholder="--">
              <el-option v-for="item in days" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </div>
          <div class="doctor_form_body_widget2">
            <div>住所</div>
            <!-- <el-cascader :options="some_options" placeholder="選択してください" @change="address_change">
            </el-cascader> -->
            <!-- <el-cascader v-model="cascader_array" :options="level1_array" :props="props"
              placeholder="選択してください"></el-cascader> -->
            <el-select v-model="level1_item" placeholder="都道府県" @change="level1_change">
              <el-option v-for="item in level1_array" :key="item.name1" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <span class="date_separator_style">/</span>
            <el-select v-model="level2_item" placeholder="市町村" @change="level2_change">
              <el-option v-for="item in level2_array" :key="item.name2" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <span class="date_separator_style">/</span>
            <el-select v-model="level3_item" placeholder="町">
              <el-option v-for="item in level3_array" :key="item.name3" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="doctor_form_body_widget2">
            <div>詳細な住所</div>
            <el-input v-model="doctor_form.clinicAddressDetail"></el-input>
          </div>
          <div class="doctor_form_body_widget2">
            <div>連絡先(代表)</div>
            <el-input v-model="doctor_form.representPhone"></el-input>
          </div>
          <div class="doctor_form_body_widget2">
            <div>メールアドレス</div>
            <el-input v-model="doctor_form.representEmail"></el-input>
          </div>
          <div class="doctor_form_body_widget1">
            <div>◆個人情報</div>
            <div class="doctor_form_widget_line"></div>
          </div>
          <div class="doctor_form_body_widget2">
            <div>氏名</div>
            <el-input v-model="doctor_form.doctorName"></el-input>
          </div>
          <div class="doctor_form_body_widget2">
            <div>ふりがな</div>
            <el-input v-model="doctor_form.doctorNameKana"></el-input>
          </div>
          <div class="doctor_form_body_widget2">
            <div>診療科目</div>
            <el-input v-model="doctor_form.doctorProject"></el-input>
          </div>
          <div class="doctor_form_body_widget2">
            <div>住所</div>
            <!-- <el-cascader :options="some_options" placeholder="選択してください" @change="address_change1">
            </el-cascader> -->
            <!-- <el-cascader v-model="cascader_array1" :options="level1_array1" :props="props1"
              placeholder="選択してください"></el-cascader> -->
            <el-select v-model="level1_item_other" placeholder="都道府県" @change="level1_change_other">
              <el-option v-for="item in level1_array_other" :key="item.name1" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <span class="date_separator_style">/</span>
            <el-select v-model="level2_item_other" placeholder="市町村" @change="level2_change_other">
              <el-option v-for="item in level2_array_other" :key="item.name2" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <span class="date_separator_style">/</span>
            <el-select v-model="level3_item_other" placeholder="町">
              <el-option v-for="item in level3_array_other" :key="item.name3" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="doctor_form_body_widget2">
            <div>詳細な住所</div>
            <el-input v-model="doctor_form.doctorAddressDetail"></el-input>
          </div>
          <div class="doctor_form_body_widget2">
            <div>性別</div>
            <el-radio v-model="doctor_form.doctorSex" :label="0">女</el-radio>
            <el-radio v-model="doctor_form.doctorSex" :label="1">男</el-radio>
          </div>
          <div class="doctor_form_body_widget2">
            <div>連絡先</div>
            <el-input v-model="doctor_form.doctorPhone"></el-input>
          </div>
          <div class="doctor_form_body_widget2">
            <div>メールアドレス</div>
            <el-input v-model="doctor_form.doctorEmail"></el-input>
          </div>
          <div class="doctor_form_body_widget1">
            <div>◆登録する項目を選択ください</div>
            <div><el-checkbox v-model="doctor_form.food" :false-label="0"
                :true-label="1">食品(冷凍食品、加工食品、飲料水等)※アレルギーがある場合は備考に記載ください</el-checkbox></div>
            <div><el-checkbox v-model="doctor_form.dailyUse" :false-label="0"
                :true-label="1">日用品(衣類、雑貨、マスク、その他)</el-checkbox></div>
            <div><el-checkbox v-model="doctor_form.supplement" :false-label="0" :true-label="1">サプリメント</el-checkbox>
            </div>
          </div>
          <div class="doctor_form_body_widget1">
            <el-input type="textarea" :rows="7" v-model="doctor_form.remark">
            </el-input>
          </div>
          <div class="doctor_form_body_widget1">
            <div>◆規約・注意事項等</div>
            <div class="doctor_form_widget_line"></div>
          </div>
          <div>
            <div>・医師モニター評価サービスの参加には「CGM Medical会員」への登録が必要となります。</div>
            <div>・評価期間は「食品7日間」「日用品7日間」「サプリメント14日間」となります。</div>
            <div>・評価用のサンプルにつきましては、郵送させていただきます。(自宅orクリニックの選択可)</div>
            <div>・サンプルの使用によって身体への悪影響があった場合、サンプル提供の会社連絡をお願い致しま
              &nbsp;&nbsp;&nbsp;列を合わせる自社製造品ではない為、弊社では責任を負いかねます。アレルギー等の情報は予め
              &nbsp;&nbsp;&nbsp;共有頂きます。</div>
            <div>・本サービスは薬機法、景品表示法、健康増進法等の法令及び関係庁の通達等の情報をもとに提供
              &nbsp;&nbsp;&nbsp;しております。</div>
            <div>・今後関係庁の見解、通達、法改正、裁判の結果を含む現状と変更が生じた場合は、サービスの提
              &nbsp;&nbsp;&nbsp;供をことわりなく停止することがございます。</div>
            <div>・頂きましたアンケート結果のみ、第三者への提供をさせていただきます。医師個人の情報に関し
              &nbsp;&nbsp;&nbsp;ては第三者への開示は行いません。(ここでいう第三者とは、医師推奨マーク提供者となります)</div>
            <div>・評価に不正があった場合は、報酬のお支払いが出来ない場合がございます。
            </div>
            <div class="doctor_form_body_widget">
              <el-checkbox v-model="doctor_form.read" :false-label="0"
                :true-label="1">上記内容を理解し医師モニター評価サービスへの参加を希望します</el-checkbox>
            </div>
            <div class="doctor_form_body_widget"> サンプル配送先は(<el-radio v-model="doctor_form.deliveryChoice"
                :label="0">自宅</el-radio><el-radio v-model="doctor_form.deliveryChoice"
                :label="1">クリニック</el-radio>)に郵送を希望します</div>
            <div>
              <div class="doctor_form_widget_line"></div>
              <br>
              <div>宛先：CGM Innovation株式会社 代表取締役 山田 太紀</div>
            </div>
          </div>
          <!-- <div class="doctor_form_body_widget2">
            <div>署名</div>
            <el-input v-model="doctor_form.signature"></el-input>
          </div> -->
        </div>
        <div class="doctor_form_widget_line"></div>
        <div class="doctor_form_footer">
          <el-button type="success" @click="doctor_form_submit">送信</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  mounted() {
    this.init();
    this.address_init();
  },
  data() {
    return {
      doctor_major_options: [
        "医師","看護師","薬剤師","獣医"
      ],
      years: [],
      months: [],
      days: [],
      year: null,
      month: null,
      day: null,
      doctor_form: {
        doctorMajor:"医師",
        doctorRecommend: 0,
        doctorProducer: 0,
        clinicName: null,
        clinicNameKana: null,
        clinicCreate: null,
        clinicAddress: null,
        clinicAddressDetail: null,
        representPhone: null,
        representEmail: null,
        doctorName: null,
        doctorNameKana: null,
        doctorProject: null,
        doctorAddress: null,
        doctorAddressDetail: null,
        doctorSex: 0,
        doctorPhone: null,
        doctorEmail: null,
        food: 0,
        dailyUse: 0,
        supplement: 0,
        remark: null,
        read: 0,
        deliveryChoice: 0,
        // signature: null,
      },
      level1_item: null,
      level2_item: null,
      level3_item: null,
      level1_array: [],
      level2_array: [],
      level3_array: [],
      level1_item_other: null,
      level2_item_other: null,
      level3_item_other: null,
      level1_array_other: [],
      level2_array_other: [],
      level3_array_other: [],
      cascader_array: [],
      level1_array1: [],
      cascader_array1: [],
      props: {
        lazy: true,
        // this指向
        lazyLoad: ((node, resolve) => {
          if (node.level == 1) {
            this.axios.get('/level2/list', {
              params: {
                name1: node.value
              }
            }).then((res) => {
              resolve(res.data.data);
            }).catch((error) => {
              console.log(error);
            })
          }
          if (node.level == 2) {
            this.axios.get('/level3/list', {
              params: {
                name2: node.value
              }
            }).then((res) => {
              resolve(res.data.data);
            }).catch((error) => {
              console.log(error);
            })
          }
        }),
      },
      props1: {
        lazy: true,
        // this指向
        // leaf 叶子节点
        lazyLoad: ((node, resolve) => {
          if (node.level == 1) {
            this.axios.get('/level2/list', {
              params: {
                name1: node.value
              }
            }).then((res) => {
              resolve(res.data.data);
            }).catch((error) => {
              console.log(error);
            })
          }
          if (node.level == 2) {
            this.axios.get('/level3/list', {
              params: {
                name2: node.value
              }
            }).then((res) => {
              resolve(res.data.data);
            }).catch((error) => {
              console.log(error);
            })
          }
        }),
      },
      some_options: [
        {
          value: "北海道",
          label: "北海道",
          children: [
            {
              value: "北海道",
              label: "北海道",
              children: [
                {
                  value: "北海道",
                  label: "北海道",
                },
              ],
            },
          ],
        },
        {
          value: "東北地方",
          label: "東北地方",
          children: [
            {
              value: "東北地方",
              label: "東北地方",
              children: [
                {
                  value: "青森",
                  label: "青森",
                },
                {
                  value: "岩手",
                  label: "岩手",
                },
                {
                  value: "宮城",
                  label: "宮城",
                },
                {
                  value: "秋田",
                  label: "秋田",
                },
                {
                  value: "山形",
                  label: "山形",
                },
                {
                  value: "福島",
                  label: "福島",
                },
              ],
            },
          ],
        },
        {
          value: "関東地方",
          label: "関東地方",
          children: [
            {
              value: "関東地方",
              label: "関東地方",
              children: [
                {
                  value: "東京",
                  label: "東京",
                },
                {
                  value: "神奈川",
                  label: "神奈川",
                },
                {
                  value: "埼玉",
                  label: "埼玉",
                },
                {
                  value: "千葉",
                  label: "千葉",
                },
                {
                  value: "茨城",
                  label: "茨城",
                },
                {
                  value: "栃木",
                  label: "栃木",
                },
                {
                  value: "群馬",
                  label: "群馬",
                },
              ],
            },
          ],
        },
        {
          value: "中部地方",
          label: "中部地方",
          children: [
            {
              value: "中部地方",
              label: "中部地方",
              children: [
                {
                  value: "新潟",
                  label: "新潟",
                },
                {
                  value: "富山",
                  label: "富山",
                },
                {
                  value: "石川",
                  label: "石川",
                },
                {
                  value: "福井",
                  label: "福井",
                },
                {
                  value: "山梨",
                  label: "山梨",
                },
                {
                  value: "長野",
                  label: "長野",
                },
                {
                  value: "岐阜",
                  label: "岐阜",
                },
                {
                  value: "静岡",
                  label: "静岡",
                },
                {
                  value: "愛知",
                  label: "愛知",
                },
              ],
            },
          ],
        },
        {
          value: "近畿地方",
          label: "近畿地方",
          children: [
            {
              value: "近畿地方",
              label: "近畿地方",
              children: [
                {
                  value: "三重",
                  label: "三重",
                },
                {
                  value: "滋賀",
                  label: "滋賀",
                },
                {
                  value: "京都",
                  label: "京都",
                },
                {
                  value: "大阪",
                  label: "大阪",
                },
                {
                  value: "兵庫",
                  label: "兵庫",
                },
                {
                  value: "奈良",
                  label: "奈良",
                },
                {
                  value: "和歌山",
                  label: "和歌山",
                },
              ],
            },
          ],
        },
        {
          value: "中国・四国地方",
          label: "中国・四国地方",
          children: [
            {
              value: "中国・四国地方",
              label: "中国・四国地方",
              children: [
                {
                  value: "鳥取",
                  label: "鳥取",
                },
                {
                  value: "島根",
                  label: "島根",
                },
                {
                  value: "岡山",
                  label: "岡山",
                },
                {
                  value: "広島",
                  label: "広島",
                },
                {
                  value: "山口",
                  label: "山口",
                },
                {
                  value: "徳島",
                  label: "徳島",
                },
                {
                  value: "香川",
                  label: "香川",
                },
                {
                  value: "愛媛",
                  label: "愛媛",
                },
                {
                  value: "高知",
                  label: "高知",
                },
              ],
            },
          ],
        },
        {
          value: "九州・沖縄地方",
          label: "九州・沖縄地方",
          children: [
            {
              value: "九州・沖縄地方",
              label: "九州・沖縄地方",
              children: [
                {
                  value: "福岡",
                  label: "福岡",
                },
                {
                  value: "佐賀",
                  label: "佐賀",
                },
                {
                  value: "長崎",
                  label: "長崎",
                },
                {
                  value: "熊本",
                  label: "熊本",
                },
                {
                  value: "大分",
                  label: "大分",
                },
                {
                  value: "宮崎",
                  label: "宮崎",
                },
                {
                  value: "鹿児島",
                  label: "鹿児島",
                },
                {
                  value: "沖縄",
                  label: "沖縄",
                },
              ],
            },
          ],
        },
      ],
    };
  },
  methods: {
    level1_change(e) {
      this.level2_item = null;
      this.level3_item = null;
      this.level2_array = [];
      this.level3_array = [];

      this.axios.get('/level2/list', {
        params: {
          name1: e
        }
      }).then((res) => {
        this.level2_array = res.data.data;
      }).catch((error) => {
        console.log(error);
      })
    },
    level2_change(e) {
      this.level3_item = null;
      this.level3_array = [];

      this.axios.get('/level3/list', {
        params: {
          name2: e
        }
      }).then((res) => {
        this.level3_array = res.data.data;
      }).catch((error) => {
        console.log(error);
      })
    },
    level1_change_other(e) {
      this.level2_item_other = null;
      this.level3_item_other = null;
      this.level2_array_other = [];
      this.level3_array_other = [];

      this.axios.get('/level2/list', {
        params: {
          name1: e
        }
      }).then((res) => {
        this.level2_array_other = res.data.data;
      }).catch((error) => {
        console.log(error);
      })
    },
    level2_change_other(e) {
      this.level3_item_other = null;
      this.level3_array_other = [];

      this.axios.get('/level3/list', {
        params: {
          name2: e
        }
      }).then((res) => {
        this.level3_array_other = res.data.data;
      }).catch((error) => {
        console.log(error);
      })
    },
    init() {
      let current_year = new Date().getFullYear();
      for (let i = 1960; i <= current_year; i++) {
        this.years.push(i);
      }
      for (let i = 1; i <= 12; i++) {
        this.months.push(i)
      }
    },
    address_init() {
      this.axios.get('/level1/list', {
        // params: {
        //   ID: 12345
        // }
      }).then((res) => {
        this.level1_array = res.data.data;
        this.level1_array_other = res.data.data;
      }).catch((error) => {
        console.log(error);
      })
    },
    leap_year() {
      if ((this.year % 4 == 0 && this.year % 100 != 0) || this.year % 400 == 0) {
        if (this.month == 2) {
          this.days = [];
          for (let i = 1; i <= 29; i++) {
            this.days.push(i)
          };
        } else if (this.month == 4 || this.month == 6 || this.month == 9 || this.month == 11) {
          this.days = [];
          for (let i = 1; i <= 30; i++) {
            this.days.push(i)
          };
        } else {
          this.days = [];
          for (let i = 1; i <= 31; i++) {
            this.days.push(i)
          };
        }
      } else {
        if (this.month == 2) {
          this.days = [];
          for (let i = 1; i <= 28; i++) {
            this.days.push(i)
          };
        } else if (this.month == 4 || this.month == 6 || this.month == 9 || this.month == 11) {
          this.days = [];
          for (let i = 1; i <= 30; i++) {
            this.days.push(i)
          };
        } else {
          this.days = [];
          for (let i = 1; i <= 31; i++) {
            this.days.push(i)
          };
        }
      }
    },
    year_change() {
      this.day = null;
      if (this.month != null) {
        this.leap_year();
      }
    },
    month_change() {
      this.day = null;
      this.leap_year();
    },
    // address_change(arr) {
    //   this.doctor_form.clinicAddress = arr[0] + '/' + arr[1] + '/' + arr[2]
    //   // this.doctor_form.clinicAddress = arr[0]
    // },
    // address_change1(arr) {
    //   this.doctor_form.doctorAddress = arr[0] + '/' + arr[1] + '/' + arr[2]
    //   // this.doctor_form.doctorAddress = arr[0]
    // },
    doctor_form_submit() {
      if (this.doctor_form.doctorRecommend == 0 && this.doctor_form.doctorProducer == 0) {
        this.$message({
          message: '医師推奨マーク 医師イチオシサービス',
          type: 'warning'
        });
        return
      }
      if (this.doctor_form.clinicName == null || this.doctor_form.clinicName == "") {
        this.$message({
          message: 'クリニック名称',
          type: 'warning'
        });
        return
      }
      if (this.doctor_form.clinicNameKana == null || this.doctor_form.clinicNameKana == "") {
        this.$message({
          message: 'クリニック名称ふりがな',
          type: 'warning'
        });
        return
      }
      if (this.year == null || this.year == "") {
        this.$message({
          message: '設立年',
          type: 'warning'
        });
        return
      }
      if (this.month == null || this.month == "") {
        this.$message({
          message: '設立月',
          type: 'warning'
        });
        return
      }
      if (this.day == null || this.day == "") {
        this.$message({
          message: '設立日',
          type: 'warning'
        });
        return
      }
      if (this.level1_item == null) {
        this.$message({
          message: '都道府県',
          type: 'warning'
        });
        return
      }
      if (this.level2_item == null) {
        this.$message({
          message: '市町村',
          type: 'warning'
        });
        return
      }
      if (this.level3_item == null) {
        this.$message({
          message: '町',
          type: 'warning'
        });
        return
      }
      if (this.doctor_form.clinicAddressDetail == null || this.doctor_form.clinicAddressDetail == "") {
        this.$message({
          message: '詳細な住所',
          type: 'warning'
        });
        return
      }
      if (this.doctor_form.representPhone == null || this.doctor_form.representPhone == "") {
        this.$message({
          message: '連絡先(代表)',
          type: 'warning'
        });
        return
      }
      if (this.doctor_form.representEmail == null || this.doctor_form.representEmail == "") {
        this.$message({
          message: 'メールアドレス',
          type: 'warning'
        });
        return
      }
      if (this.doctor_form.doctorName == null || this.doctor_form.doctorName == "") {
        this.$message({
          message: '氏名',
          type: 'warning'
        });
        return
      }
      if (this.doctor_form.doctorNameKana == null || this.doctor_form.doctorNameKana == "") {
        this.$message({
          message: 'ふりがな',
          type: 'warning'
        });
        return
      }
      if (this.doctor_form.doctorProject == null || this.doctor_form.doctorProject == "") {
        this.$message({
          message: '診療科目',
          type: 'warning'
        });
        return
      }
      // if (this.cascader_array1.length != 3) {
      //   this.$message({
      //     message: '住所',
      //     type: 'warning'
      //   });
      //   return
      // }

      if (this.level1_item_other == null) {
        this.$message({
          message: '都道府県',
          type: 'warning'
        });
        return
      }
      if (this.level2_item_other == null) {
        this.$message({
          message: '市町村',
          type: 'warning'
        });
        return
      }
      if (this.level3_item_other == null) {
        this.$message({
          message: '町',
          type: 'warning'
        });
        return
      }
      if (this.doctor_form.doctorAddressDetail == null || this.doctor_form.doctorAddressDetail == "") {
        this.$message({
          message: '詳細な住所',
          type: 'warning'
        });
        return
      }
      if (this.doctor_form.doctorPhone == null || this.doctor_form.doctorPhone == "") {
        this.$message({
          message: '連絡先',
          type: 'warning'
        });
        return
      }
      if (this.doctor_form.doctorEmail == null || this.doctor_form.doctorEmail == "") {
        this.$message({
          message: 'メールアドレス',
          type: 'warning'
        });
        return
      }
      if (this.doctor_form.food == 0 && this.doctor_form.dailyUse == 0 && this.doctor_form.supplement == 0) {
        this.$message({
          message: '食品 日用品 サプリメント',
          type: 'warning'
        });
        return
      }
      if (this.doctor_form.read == null || this.doctor_form.read == "") {
        this.$message({
          message: '上記内容を理解し医師モニター評価サービスへの参加を希望します',
          type: 'warning'
        });
        return
      }
      // if (this.doctor_form.signature == null || this.doctor_form.signature == "") {
      //   this.$message({
      //     message: '署名',
      //     type: 'warning'
      //   });
      //   return
      // }

      this.doctor_form.clinicCreate = this.year + '-' + this.month.toString().padStart(2, 0) + '-' + this.day.toString().padStart(2, 0)

      this.doctor_form.clinicAddress = this.level1_item + '/' + this.level2_item + '/' + this.level3_item
      this.doctor_form.doctorAddress = this.level1_item_other + '/' + this.level1_item_other + '/' + this.level3_item_other

      this.axios.post('/doctorForm/save', this.doctor_form)
        .then((res) => {
          if (res.data.code == 200) {
            this.doctor_form.doctorMajor="医師";
            this.doctor_form.doctorRecommend=0;
            this.doctor_form.doctorProducer=0;
            this.doctor_form.clinicName=null;
            this.doctor_form.clinicNameKana=null;
            this.doctor_form.clinicCreate=null;
            this.doctor_form.clinicAddress=null;
            this.doctor_form.clinicAddressDetail=null;
            this.doctor_form.representPhone=null;
            this.doctor_form.representEmail=null;
            this.doctor_form.doctorName=null;
            this.doctor_form.doctorNameKana=null;
            this.doctor_form.doctorProject=null;
            this.doctor_form.doctorAddress=null;
            this.doctor_form.doctorAddressDetail=null;
            this.doctor_form.doctorSex=0;
            this.doctor_form.doctorPhone=null;
            this.doctor_form.doctorEmail=null;
            this.doctor_form.food=0;
            this.doctor_form.dailyUse=0;
            this.doctor_form.supplement=0;
            this.doctor_form.remark=null;
            this.doctor_form.read=0;
            this.doctor_form.deliveryChoice=0;
            // signature=null;

            this.year=null,
            this.month=null,
            this.day=null,
            // this.months=[],
            this.days=[],
            this.level1_item=null,
            this.level2_item=null,
            this.level3_item=null,
            this.level2_array=[],
            this.level3_array=[],
            this.level1_item_other=null,
            this.level2_item_other=null,
            this.level3_item_other=null,
            this.level2_array_other=[],
            this.level3_array_other=[],

            // this.$message({
            //   message: '送信が完了しました！',
            //   type: 'success'
            // });
            this.$notify({
              title: '成功',
              message: '送信が完了しました！',
              type: 'success'
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }
};
</script>

<style lang="scss">
* {
  margin: 0;
  font-family: "PingFang";
}

@font-face {
  font-family: "PingFang";
  src: url("./assets/PingFang Regular.ttf");
}

.doctor_form_side {
  background: rgb(245, 246, 248);
  padding: 20px 0;
}

.doctor_form_fixed {
  width: 768px;
  margin: 0 auto;
}

@media (width <=768px) {
  .doctor_form_fixed {
    width: 100%;
  }
}

.doctor_form_logo {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.doctor_form_logo_style {
  width: 270px;
}

@media (width <=768px) {
  .doctor_form_logo_style {
    width: 140px;
  }
}

.doctor_form_logo_title {
  font-size: 24px;
  font-weight: bold;
}

@media (width <=768px) {
  .doctor_form_logo_title {
    font-size: 14px;
  }
}

.doctor_form_content {
  background: #fff;
  box-shadow: 0 2px 9px 0 hsla(0, 0%, 65%, .5);
}

.doctor_form_head_banner {
  background: rgb(0, 184, 153);
  height: 20px;
}

.doctor_form_head_title {
  font-size: 20px;
  font-weight: bold;
  padding: 30px;
}

.doctor_form_body {
  padding: 30px;
}

.doctor_form_body_widget {
  margin: 24px 0;
}

.doctor_form_body_widget1 {
  margin: 24px 0;
  font-weight: bold;
}

.doctor_form_widget_line {
  border-top: 1px solid;
  border-color: rgb(200, 205, 212);
}

.doctor_form_body_widget2 {
  width: 77%;
  margin: 24px 0;
  font-weight: bold;
}

@media (width <=768px) {
  .doctor_form_body_widget2 {
    width: 100%;
  }
}

@media (width <=768px) {

  .el-checkbox,
  .el-checkbox__input {
    white-space: normal !important;
  }
}

.el-select {
  width: 37%;
}

.el-cascader {
  width: 77%;
}

.date_separator_style {
  margin: 0 4px;
}

.doctor_form_footer {
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
